
import { useState } from "react";
import { FilledButton } from "../components/common/Button";

import { BRAND_ASSETS } from "../config/defaultAssetUrls";
import TextInputField from "../components/common/TextInputField";
import { isEmail } from "../utils/regularExpressions";
import useAuth from "../hooks/useAuth";
import { LOGIN_ROUTE } from "../App";
import { EUserType } from "../data_models/enums";


const ForgotPasswordPage: React.FC = () => {

    const { error, loading, sendForgotPasswordEmail } = useAuth();
    const [email, setEmail] = useState('');
    const [buttonDisabled, setButtonDisabled] = useState(true);

    const [emailError, setEmailError] = useState('');
    const [errorFeedback, setErrorFeedback] = useState('');
    const [successFeedback, setSuccessFeedback] = useState('');

    const resetFeedback = () => {
        setErrorFeedback('');
        setSuccessFeedback('');
        setEmailError('');
    }

    const onChangeEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value);
        setButtonDisabled(!liveValidateEmail());
    }

    const liveValidateEmail = () => {
        resetFeedback();

        if (!email || !isEmail(email)) {
            return false;
        }
        return true;
    }

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        resetFeedback();
        // check email

        if (!email) {
            setEmailError('Email is required');
            return;
        }
        if (!isEmail(email)) {
            setEmailError('Invalid email address');
            return;
        }

        sendForgotPasswordEmail(email)
            .then((response) => {
                setSuccessFeedback('Password reset email sent to ' + email + '.');
            })
            .catch((error) => {
                console.error(error);
                setErrorFeedback(error);
            }).finally(() => {
                setEmail('');
            });
    };

    return (
        <div className="relative min-h-screen w-full overflow-hidden">
            {/* Blurred dots */}
            <div className="absolute top-0 left-0 w-64 h-64 rounded-full bg-primary-500/30 blur-3xl" />
            <div className="absolute -top-12 left-64 w-64 h-64 rounded-full bg-primary-700/25 blur-3xl" />
            <div className="absolute -bottom-10 -right-5 w-64 h-64 rounded-full bg-primary-500/20 blur-3xl" />
            <div className="absolute bottom-36 right-5 w-64 h-64 rounded-full bg-secondary-500/20 blur-3xl" />
            <div className="absolute bottom-12 left-12 w-48 h-48 rounded-full bg-primary-200/30 blur-3xl" />

            {/* Content container */}
            <div className="relative z-10 flex flex-col min-h-[calc(100vh-4rem)] md:min-h-[calc(100vh-5rem)] max-w-7xl mx-auto">
                <div className="flex min-h-full flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8">
                    <div className="sm:mx-auto sm:w-full sm:max-w-md">
                        <img
                            alt="Your Company"
                            src={BRAND_ASSETS.LOGO_SMALL_BLACK}
                            className="mx-auto h-10 w-auto"
                        />
                        <h2 className="mt-6 text-center text-2xl/9 font-bold tracking-tight text-gray-900">
                            Forgot Password
                        </h2>
                    </div>

                    {/* Login Form */}
                    <div className="mt-10 mx-auto w-full md:max-w-[650px]">

                        {/* Form */}
                        <div className="md:-mt-5 bg-white px-6 py-12 shadow-md border border-gray-100 md:rounded-lg md:px-12 flex-1">
                            <form onSubmit={handleSubmit} className="space-y-4">

                                <TextInputField
                                    type="email"
                                    id="email"
                                    label="Email Address"
                                    value={email}
                                    onChange={onChangeEmail}
                                    error={emailError}
                                    autoComplete="email"
                                />



                                <div className='mt-4' />
                                {/* Submit Button */}
                                <FilledButton
                                    isLoading={loading}
                                    fullWidth
                                    type='submit'
                                    disabled={buttonDisabled}
                                >Send Reset Password Email
                                </FilledButton>
                            </form>
                        </div>
                    </div>

                    <p className="mt-10 text-center text-sm/6 text-gray-500">
                        Back to{' '}
                        <a href={`${LOGIN_ROUTE}?userType=${EUserType.FREELANCER}`} className="font-semibold text-primary-600 hover:text-primary-500">
                            Login
                        </a>
                    </p>
                </div>

            </div>
        </div>
        // <div className="h-screen flex justify-center p-20">
        //     <div className="flex flex-col items-center">
        //         <img
        //             src={BRAND_ASSETS.LOGO}
        //             alt="Gamershome Logo"
        //             className="w-80"
        //         />

        //         <div className="my-10 text-center">
        //             <h4>Forgot Password?</h4>
        //             <p>Enter your email to receive a link to change your password</p>
        //         </div>
        //         {!successFeedback && <form
        //             className="flex flex-col space-y-4"
        //             onSubmit={handleSubmit}>

        //             <TextInputField
        //                 type="email"
        //                 id="email"
        //                 label="Email Address"
        //                 value={email}
        //                 onChange={(e) => setEmail(e.target.value)}
        //                 error={emailError}
        //             />


        //             <FilledButton
        //                 fullWidth
        //                 isLoading={loading}
        //             >
        //                 Send Reset Password Email
        //             </FilledButton>
        //         </form>}
        //         <div>
        //             {errorFeedback && <p className='text-danger'>{errorFeedback}</p>}
        //             {successFeedback && <p className='text-success'>{successFeedback}</p>}
        //         </div>

        //     </div>

        // </div>
    );
};

export default ForgotPasswordPage;